export default {
  SET_LOADING: 'SET_LOADING',
  SET_ERROR: 'SET_ERROR',
  SET_CREDENTIALS_ERROR: 'SET_CREDENTIALS_ERROR',
};
